import React from 'react'
import PropTypes from 'prop-types'

import AttachmentsList from 'components/AttachmentsList'
import moment from 'moment'

import styles from './styles'

function FinancialPendingsAnswer(props) {
  const { questionData } = props
  const answers = questionData?.answer?.answer_object
  const classes = styles()

  return (
    <div className={classes.root}>
      <h2>Pendência Financeira</h2>
      <div className={classes.formWrapper}>
        <h3>Pergunta:</h3>
        <p>{questionData.text}</p>
        <div className={classes.subject}>
          <p>
            <span>Data de vencimento: </span>
            {questionData.occurrence.expiration_date}
          </p>
          <p>
            <span>Data da inclusão: </span>
            {questionData.occurrence.inclusion_date}
          </p>
          <p>
            <span>Fonte: </span>
            {questionData.occurrence.informant}
          </p>
          <p>
            <span>Credor: </span>
            {questionData.occurrence.creditor}
          </p>
          <p>
            <span>Número do contrato: </span>
            {questionData.occurrence.contract || 'N/A'}
          </p>
          <p>
            <span>Valor: </span>
            {`${questionData.occurrence.currency} ${questionData.occurrence.value}`}
          </p>
        </div>
        {answers && (
          <React.Fragment>
            <h3>Resposta:</h3>
            <div className={classes.subject}>
              <p>
                <span>Reconhece essa restrição:</span>{' '}
                {answers.recognizes_the_restrictions ? 'sim' : 'não'}
              </p>
              {answers.recognizes_the_restrictions ? (
                <React.Fragment>
                  <p>
                    <span> É uma situação de cobrança indevida: </span>
                    {answers.is_improper_billing ? 'sim' : 'não'}
                  </p>
                  {answers.is_improper_billing ? (
                    <React.Fragment>
                      <p>
                        <span>A situação foi judicializada:</span>{' '}
                        {answers.judicialised_the_situation ? 'sim' : 'não'}
                      </p>
                      {answers.judicialised_the_situation ? (
                        <AttachmentsList
                          expanded
                          attachments={answers.evidence_of_judicialization}
                          title="Evidencias de judicialização"
                        />
                      ) : null}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <p>
                        <span>Há algum plano de pagamento:</span>{' '}
                        {answers.has_payment_plan ? 'sim' : 'não'}
                      </p>
                      {answers.has_payment_plan ? (
                        <React.Fragment>
                          <p>
                            <span>Prazo esperado para regularização:</span>{' '}
                            {moment(
                              answers.expected_deadline_to_regularize,
                            ).format('DD/MM/YYYY')}
                          </p>
                          <AttachmentsList
                            expanded
                            attachments={answers.proof_of_discharge_negotiation}
                            title="Comprovantes de quitação/negociação"
                          />
                        </React.Fragment>
                      ) : null}
                    </React.Fragment>
                  )}
                </React.Fragment>
              ) : null}
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

FinancialPendingsAnswer.propTypes = {
  questionData: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    text: PropTypes.string,
    occurrence: PropTypes.object,
    answered: PropTypes.bool.isRequired,
    subject: PropTypes.string.isRequired,
    answer: PropTypes.object,
  }).isRequired,
}

export default FinancialPendingsAnswer
